import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";

class DataTablesResponse {
  data: any;
  draw: any;
  recordsFiltered: any;
  recordsTotal: any;
}

class Reg_Workshops {
  id: number;
  name: string;
  email: string;
  query: string;
  created_by: string;
  created_at: string;
}

@Component({
  selector: "app-cii-registered-workshops",
  templateUrl: "./cii-registered-workshops.component.html",
  styleUrls: ["./cii-registered-workshops.component.sass"],
})
export class CiiRegisteredWorkshopsComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };

  dtTrigger = new Subject();
  regWorkshopList: Reg_Workshops[] = [];
  showloding = true;
  lodingImage = false;
  totalWorkshops: any;
  start: number = 0;
  pageLength: number = 10;

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    window.scroll(0, 0);

    this.loadHide();
    this.getAllFaqs();
  }


    getRowNumber(index: number): number {
    return this.start + index + 1;
  }
  getAllFaqs() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/admin/workshop-reg/workshop-reg-list",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters))
              ),
            },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            var resp = JSON.parse(output);
            this.regWorkshopList = resp["data"];
            this.totalWorkshops = resp["recordsTotal"];
            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },

      columns: [
        { data: "id" },
        { data: "full_name" },
        { data: "mobile" },
        { data: "email" },
        { data: "message" },
        { data: "created_at" },
      ],
    };
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
